import { ActionHandler } from '../actionHandler';

const sizes = {
  xs: '',
  sm: 'w-5 h-5 [&>svg]:w-3 [&>svg]:h-3',
  md: 'w-6 h-6 [&>svg]:w-5 [&>svg]:h-5',
  lg: 'w-8 h-8 [&>svg]:w-6 [&>svg]:h-6'
};

export function IconButton({ icon: Icon, size = 'md', ...rest }) {
  return (
    <ActionHandler {...rest}>
      <span
        className={`${sizes[size]} rounded-full bg-slate-50 flex items-center justify-center text-slate-500 hover:bg-slate-100 hover:text-slate-700`}
      >
        <Icon />
      </span>
    </ActionHandler>
  );
}
